export default __webpack_public_path__ + "static/media/menu.03ec7e26.svg";